import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/badge.svg'
import _imports_1 from '../../../assets/icons/mic-filled-icon.svg'
import _imports_2 from '../../../assets/icons/yellow-building-filled-icon.svg'
import _imports_3 from '../../../assets/icons/yellow-location-icon.svg'
import _imports_4 from '../../../assets/icons/yellow-certificate-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-515e140b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "tab__area__wrapper !tw-m-0"
}
const _hoisted_2 = { class: "tab__area__blocks tw-pb-8" }
const _hoisted_3 = { class: "tab__area__title md:!tw-leading-[28px]" }
const _hoisted_4 = {
  key: 0,
  class: "tw-flex tw-items-center tw-gap-2"
}
const _hoisted_5 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-justify-start tw-items-start tw-gap-2 tw-w-full rlg:tw-flex-row rlg:tw-items-center rlg:tw-justify-between"
}
const _hoisted_6 = { class: "tw-flex tw-flex-col tw-justify-start tw-items-start tw-gap-2 rlg:tw-gap-4 rlg:tw-items-center rlg:tw-flex-row" }
const _hoisted_7 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_8 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_9 = {
  key: 2,
  class: "tab__area__buttons mobile"
}
const _hoisted_10 = { class: "tab__area__img !tw-mt-0 !tw-rounded-lg" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "tab__area__content" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "tab__area__content__title" }, "About", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab__area__info" }, " NOTE: Please check the entry requirements before reserving your spot. ", -1))
const _hoisted_15 = {
  key: 3,
  class: "tab__area__content"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "tab__area__content__title" }, "Summary", -1))
const _hoisted_17 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-2" }
const _hoisted_18 = { key: 4 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "tab__area__content__title" }, "Breakdown", -1))
const _hoisted_20 = {
  key: 0,
  class: "tab__area__list__item__break"
}
const _hoisted_21 = { class: "tab__area__content" }
const _hoisted_22 = { class: "tab__area__content__title" }
const _hoisted_23 = { class: "tab__area__cards" }
const _hoisted_24 = { class: "tab__area__content__title" }
const _hoisted_25 = { class: "tab__area__cards__list" }
const _hoisted_26 = {
  key: 0,
  class: "courses__card__prefix"
}
const _hoisted_27 = { class: "left__prefix" }
const _hoisted_28 = { class: "right__prefix" }
const _hoisted_29 = { class: "tab__area__cards__title" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "open-logo",
  src: _imports_0
}, null, -1))
const _hoisted_31 = { class: "tab__area__cards__description" }
const _hoisted_32 = { class: "tab__area__content__footer" }
const _hoisted_33 = {
  key: 0,
  class: "tab__area__content__description"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tab__area__content__description" }, [
  /*#__PURE__*/_createTextVNode(" Reserve your spot today!"),
  /*#__PURE__*/_createElementVNode("span", null, " NOTE: Please check the entry requirements before reserving your spot.")
], -1))
const _hoisted_35 = { class: "tab__area__buttons desktop tw-flex !tw-flex-col !tw-items-center !tw-gap-2 !tw-justify-center !tw-w-full" }
const _hoisted_36 = {
  key: 0,
  class: "tab__area__right__block !tw-bg-[#F8FBFD] tw-box-border tw-border-solid tw-border-[1px] tw-rounded-[6.58px] tw-border-[#DFDFDF]"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "enroll__content" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "title" }, "You’re signed up to this course")
], -1))
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "icon_abs" }
const _hoisted_40 = { class: "proj_loop_box" }
const _hoisted_41 = { class: "title" }
const _hoisted_42 = {
  key: 1,
  class: "course_total"
}
const _hoisted_43 = {
  key: 1,
  class: "tab__area__right__block !tw-bg-[#F8FBFD] tw-box-border tw-border-solid tw-border-[1px] tw-rounded-[6.58px] tw-border-[#DFDFDF]"
}
const _hoisted_44 = {
  key: 0,
  class: "title"
}
const _hoisted_45 = { class: "tw-flex-row-between tw-p-4 tw-border-[1px] tw-border-solid tw-border-[#4F55F0] tw-rounded-[8px] tw-bg-[rgba(79,85,240,0.1)] tw-cursor-pointer" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab__area__list" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "title" }, "Summary"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "tab__area__list__icon" }, [
        /*#__PURE__*/_createElementVNode("img", {
          class: "open-logo",
          src: _imports_1
        })
      ]),
      /*#__PURE__*/_createElementVNode("p", null, "English")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "tab__area__list__icon" }, [
        /*#__PURE__*/_createElementVNode("img", {
          class: "open-logo",
          src: _imports_2
        })
      ]),
      /*#__PURE__*/_createElementVNode("p", null, "In Person & E-Learning Lessons")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "tab__area__list__icon" }, [
        /*#__PURE__*/_createElementVNode("img", {
          class: "open-logo",
          src: _imports_3
        })
      ]),
      /*#__PURE__*/_createElementVNode("p", null, "Locations Nationwide")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "tab__area__list__icon" }, [
        /*#__PURE__*/_createElementVNode("img", {
          class: "open-logo",
          src: _imports_4
        })
      ]),
      /*#__PURE__*/_createElementVNode("p", null, "Certification on completion")
    ])
  ])
], -1))
const _hoisted_47 = { class: "tab__area__price" }
const _hoisted_48 = { class: "tab__area__item tw-flex tw-flex-col tw-items-start" }
const _hoisted_49 = { class: "tw-flex tw-flex-col tw-items-end tw-gap-0" }
const _hoisted_50 = { class: "tab__area__item tw-flex tw-flex-col tw-items-start" }
const _hoisted_51 = { class: "tw-flex tw-flex-col tw-items-end tw-gap-0" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "blue-text remove-padding" }, " I have read and agree with the ", -1))
const _hoisted_53 = { class: "tw-w-full tw-mt-2 tw-flex tw-items-center tw-justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalenderView = _resolveComponent("CalenderView")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_MapMarkerBlueIcon = _resolveComponent("MapMarkerBlueIcon")!
  const _component_Text = _resolveComponent("Text")!
  const _component_EnrolledChipState = _resolveComponent("EnrolledChipState")!
  const _component_MapMarkerYellowIcon = _resolveComponent("MapMarkerYellowIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ToolTip = _resolveComponent("ToolTip")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_CheckElegibilityModal = _resolveComponent("CheckElegibilityModal")!
  const _component_ElegibilityModal = _resolveComponent("ElegibilityModal")!
  const _component_CoursesTermsConditionModal = _resolveComponent("CoursesTermsConditionModal")!
  const _component_PageRestrictionNoticeModal = _resolveComponent("PageRestrictionNoticeModal")!
  const _component_ReserveSpotsModal = _resolveComponent("ReserveSpotsModal")!
  const _component_CoursePreEnrollTermsConditionsModal = _resolveComponent("CoursePreEnrollTermsConditionsModal")!
  const _component_SuccessReserveSpotModal = _resolveComponent("SuccessReserveSpotModal")!
  const _component_SelectWorkstationModal = _resolveComponent("SelectWorkstationModal")!
  const _component_AssignCourseSlotToMemberModal = _resolveComponent("AssignCourseSlotToMemberModal")!
  const _component_TpSubscriptionModal = _resolveComponent("TpSubscriptionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isShowCalender)
      ? (_openBlock(), _createBlock(_component_CalenderView, {
          key: 0,
          memberList: $setup.memberList
        }, null, 8, ["memberList"]))
      : _createCommentVNode("", true),
    (!$setup.isShowCalender && $setup.detailsItems)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!$setup.isPersonalAccountWorkStation)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                class: "blue-text",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onClickBackCoursesButton && $setup.onClickBackCoursesButton(...args)))
              }, [
                _createVNode(_component_v_icon, { icon: "mdi-chevron-left" }),
                _createTextVNode("Back to Courses ")
              ]))
            : (_openBlock(), _createElementBlock("label", {
                key: 1,
                class: "blue-text",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.onClickBackCoursesButton && $setup.onClickBackCoursesButton(...args)))
              }, [
                _createVNode(_component_v_icon, { icon: "mdi-chevron-left" }),
                _createTextVNode("Take me Back ")
              ])),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["tab__area__left__block tw-flex tw-flex-col tw-gap-4 tw-p-[1.5rem] tw-bg-[#F8FBFD] tw-box-border tw-border-solid tw-border-[1px] tw-rounded-[6.58px] tw-border-[#DFDFDF]", {
          'tw-bg-white tw-p-3 tw-box-border tw-rounded-[8px]':
            $setup.isPersonalAccountWorkStation,
        }])
            }, [
              _createElementVNode("h4", _hoisted_3, _toDisplayString($setup.detailsItems?.name), 1),
              ($setup.isPersonalAccountWorkStation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_MapMarkerBlueIcon),
                    _createVNode(_component_Text, {
                      variant: "span",
                      textColor: "#264FD5",
                      textWeight: "400"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("In-Person & E-Learning")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              ($setup.isEnrollRoute || $setup.isAssignRoute)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_EnrolledChipState, {
                      statusLabel: $setup.lastCourseStatus?.label
                    }, null, 8, ["statusLabel"]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_MapMarkerYellowIcon),
                        _createVNode(_component_Text, {
                          variant: "span",
                          textWeight: "500"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.selectedEnrolledCourseScheduleAddress), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_MapMarkerBlueIcon),
                        _createVNode(_component_Text, {
                          variant: "span",
                          textColor: "#264FD5",
                          textWeight: "400"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Online & In-Person")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
            !$setup.isPersonalAccountWorkStation && !$setup.isEnrollRoute && !$setup.isAssignRoute
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_Button, {
                      variant: "accent",
                      label: "Enrol For Free*",
                      onClick: $setup.goToCalender,
                      isActive: $setup.isSportDisable || !$setup.isEligible
                    }, null, 8, ["onClick", "isActive"]),
                    (!$setup.isSportDisable && !$setup.isEligible)
                      ? (_openBlock(), _createBlock(_component_Text, {
                          key: 0,
                          class: "tw-mt-2",
                          textAlign: "center",
                          lineHeight: "18px",
                          variant: "p",
                          textColor: "red"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("You are not eligible for this course. Please check course eligibility to continue.")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                ($setup.detailsItems?.thumbnail)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "align-end text-white",
                      height: "234",
                      cover: "",
                      src: require('@/assets/images/course/' + $setup.detailsItems?.thumbnail)
                    }, null, 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.detailsItems?.about, (text, index) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: index,
                    class: "tab__area__content__description"
                  }, _toDisplayString(text), 1))
                }), 128))
              ]),
              _hoisted_14,
              ($setup.route.params.courseId == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.detailsItems?.summary, (summary, index) => {
                        return (_openBlock(), _createBlock(_component_Text, {
                          variant: "p",
                          key: index
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(summary.title) + " - ", 1),
                            _createVNode(_component_Text, {
                              variant: "p",
                              textWeight: "400",
                              textColor: "rgba(12, 15, 74, 0.8)"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(summary?.description), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($setup.detailsItems?.breakDown?.length && $setup.route.params.courseId == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.detailsItems.breakDown, (week, weekIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: week.id,
                        class: "tab__area__list__title"
                      }, [
                        _createElementVNode("h6", null, _toDisplayString(week.label), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week.days, (day, dayIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: dayIndex,
                            class: "tab__area__list__item"
                          }, [
                            _createElementVNode("p", null, [
                              _createElementVNode("span", null, "Day " + _toDisplayString(weekIndex * 5 + dayIndex + 1), 1),
                              _createTextVNode("- " + _toDisplayString(day), 1)
                            ])
                          ]))
                        }), 128)),
                        (weekIndex === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, " - - - 10-DAY BREAK - - - "))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("h5", _hoisted_22, _toDisplayString($setup.route.params.courseId == 1
                ? "Completing this course will enable you to"
                : "After completing this course you will be able to"), 1),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.detailsItems?.aims, (aim, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "tab__area__content__description",
                      key: index
                    }, [
                      _createVNode(_component_v_icon, { icon: "mdi-check-circle-outline" }),
                      _createTextVNode(" " + _toDisplayString(aim), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("h5", _hoisted_24, _toDisplayString($setup.route.params.courseId == 1
                ? "Qualifications received after completion"
                : "Course Details"), 1),
                _createElementVNode("div", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.detailsItems?.courseDetails, (courseDetail, index) => {
                    return (_openBlock(), _createBlock(_component_v_card, {
                      key: index,
                      class: _normalizeClass(["tab__area__card__item !tw-bg-[#F3F3F6]", { '!tw-bg-[#F3F3F6]': $setup.isPersonalAccountWorkStation }])
                    }, {
                      default: _withCtx(() => [
                        ($setup.route.params.courseId == 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("span", _hoisted_27, _toDisplayString(courseDetail?.dayCount) + " " + _toDisplayString(courseDetail?.dayCount > 1 ? "Days" : "Day"), 1),
                              _createElementVNode("p", _hoisted_28, [
                                _createVNode(_component_v_icon, { icon: "mdi-map-marker" }),
                                _createTextVNode(" " + _toDisplayString(courseDetail?.locationType), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _createTextVNode(" " + _toDisplayString(courseDetail?.name), 1)
                        ]),
                        _createElementVNode("p", _hoisted_31, _toDisplayString(courseDetail?.description), 1)
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_32, [
                  ($setup.route.params.courseId == 1)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_33, " Additionally, you’ll receive practical site experience with a qualified heat pump installer. "))
                    : _createCommentVNode("", true),
                  _hoisted_34
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                (
              $setup.getUserWorkStationFieldAccess &&
              !$setup.isPersonalAccountWorkStation &&
              !$setup.isEnrollRoute &&
              !$setup.isAssignRoute
            )
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      variant: "accent",
                      label: "Enrol For Free*",
                      onClick: $setup.goToCalender,
                      isActive: $setup.isSportDisable || !$setup.isEligible
                    }, null, 8, ["onClick", "isActive"]))
                  : _createCommentVNode("", true),
                ($setup.isPersonalAccountWorkStation)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      variant: "accent",
                      label: "reserve my spot",
                      onClick: $setup.onSelectDate
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (!$setup.isSportDisable && !$setup.isEligible)
                  ? (_openBlock(), _createBlock(_component_Text, {
                      key: 2,
                      textAlign: "center",
                      lineHeight: "18px",
                      variant: "p",
                      textColor: "red"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("You are not eligible for this course. Please check course eligibility to continue.")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            ($setup.isEnrollRoute || $setup.isAssignRoute)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createVNode(_component_v_card, { class: "tab__area__right__block__card" }, {
                    default: _withCtx(() => [
                      _hoisted_37,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterCourseStatusList, (status) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: status.id,
                          class: _normalizeClass([
              { completed: status.completed && status.isShow },
              { proj_loop: status.isShow },
            ])
                        }, [
                          (status.isShow)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                  _createVNode(_component_v_icon, { icon: "mdi mdi-home-circle" })
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("div", _hoisted_41, _toDisplayString(status.label), 1),
                                  _createElementVNode("p", null, _toDisplayString(status.info), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128)),
                      ($setup.isAssignRoute)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            class: "download__btn button button-purple-border",
                            disabled: $setup.getSelectedCourse?.result != '1',
                            onClick: $setup.onClickDownloadCertificate,
                            "prepend-icon": "mdi-download"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Download Certificate")
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"]))
                        : _createCommentVNode("", true),
                      ($setup.isEnrollRoute && $setup.isUserHasCourseAssignPermission)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createTextVNode(" Total: " + _toDisplayString($setup.getSelectedCourse?.selectedSpotCount) + " Spots ", 1),
                            _createVNode(_component_v_btn, {
                              variant: "plain",
                              height: "auto",
                              "append-icon": "mdi-chevron-right",
                              class: "blue-text",
                              onClick: $setup.toggleAssignCourseSlotToMemberModal
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Assign Members to Spots")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]))
              : ($setup.getUserWorkStationFieldAccess)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createVNode(_component_v_card, { class: "tab__area__right__block__card" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["tw-flex tw-items-center tw-justify-between tw-mb-1", { 'tw-pt-[24px]': !$setup.isPersonalAccountWorkStation }])
                        }, [
                          (!$setup.isPersonalAccountWorkStation)
                            ? (_openBlock(), _createElementBlock("h4", _hoisted_44, " Entry requirements "))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ToolTip, {
                            maxWidth: 360,
                            effect: "light",
                            description: "<div class=\"\">\n    <h4 class=\"text-base text-[#0C0F4A] font-bold leading-[20.08px]\">Why is the minimum 3-month subscription\n      <span class=\"text-md font-normal text-[#0c0f4a80]\">(per spot)</span> required for the courses?\n    </h4>\n    <p class=\"text-md font-normal text-[#0c0f4a] leading-[17.57px] mt-4\">\n      The 3-month minimum subscription ensures that we can provide you with the necessary support and resources to\n      complete your course successfully. This includes your workstation setup <span\n        class=\"text-sm font-normal text-[#0c0f4a80] leading-[15.06px]\">\n        (required for the course enrolment)</span>, ongoing verification, and the administrative processes involved from\n      onboarding to receiving your certificate.</p>\n    <p class=\"text-sm font-normal text-[#0c0f4a] leading-[15.06px] italic mt-7\">Note: After 3 months your\n      subscription will automatically switch to monthly plan, unless you opt to cancel or\n      switch to a yearly plan.</p>\n  </div>"
                          })
                        ], 2),
                        _createElementVNode("div", _hoisted_45, [
                          _createVNode(_component_Text, { variant: "p" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Check eligibility to see if you meet the entry requirements.")
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", {
                          class: "tw-flex-row-between tw-px-4 tw-py-2 tw-border-[1px] tw-border-solid tw-border-[#3366FF] tw-rounded-[8px] tw-bg-transparent tw-cursor-pointer tw-mt-3",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.toggleElegibilityModal && $setup.toggleElegibilityModal(...args)))
                        }, [
                          _createVNode(_component_Text, {
                            variant: "p",
                            textColor: "#4B4BFF"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Check eligibility")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-chevron-right",
                            color: "#4B4BFF"
                          })
                        ]),
                        _hoisted_46,
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createElementVNode("div", _hoisted_48, [
                                _createVNode(_component_Text, {
                                  variant: "p",
                                  lineHeight: "18px"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Sole Trader/ LTD Sole Director")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Text, {
                                  variant: "xsmall",
                                  textColor: "rgba(12, 15, 74, 0.5)",
                                  lineHeight: "18px"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("(100% Subsidy)")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_49, [
                                _createVNode(_component_Text, {
                                  class: "tw-line-through",
                                  variant: "p",
                                  textColor: "#7E82A2",
                                  textWeight: "600",
                                  lineHeight: "18px"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("£" + _toDisplayString($setup.detailsItems?.title ===
                      "Solar PV, Battery Storage & EV Charging Level 3"
                        ? "1,837"
                        : "1,558"), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Text, {
                                  variant: "p",
                                  textColor: "#FFA500",
                                  lineHeight: "18px"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("FREE")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("div", _hoisted_50, [
                                _createVNode(_component_Text, {
                                  variant: "p",
                                  lineHeight: "18px"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Limited Company")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Text, {
                                  variant: "xsmall",
                                  textColor: "rgba(12, 15, 74, 0.5)",
                                  lineHeight: "18px"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("(90% Subsidy)")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_51, [
                                _createVNode(_component_Text, {
                                  class: "tw-line-through",
                                  variant: "p",
                                  textColor: "#7E82A2",
                                  textWeight: "600",
                                  lineHeight: "18px"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("From")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Text, {
                                  variant: "p",
                                  textColor: "#FFA500",
                                  lineHeight: "18px"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("£155.80")
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ])
                        ]),
                        (!$setup.isPersonalAccountWorkStation)
                          ? (_openBlock(), _createBlock(_component_v_checkbox, {
                              key: 0,
                              modelValue: $setup.tcOptIn,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.tcOptIn) = $event)),
                              class: "tab__area__checkbox",
                              color: "#4B4BFF"
                            }, {
                              label: _withCtx(() => [
                                _createElementVNode("p", null, [
                                  _hoisted_52,
                                  _createElementVNode("span", {
                                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.openTermsServiceModal && $setup.openTermsServiceModal(...args))),
                                    class: "yellow-text"
                                  }, " Terms of Service & Privacy Policy")
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]))
                          : _createCommentVNode("", true),
                        (!$setup.isPersonalAccountWorkStation)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 1,
                              variant: "accent",
                              label: "Enrol For Free*",
                              onClick: $setup.goToCalender,
                              disabled: !$setup.tcOptIn
                            }, null, 8, ["onClick", "disabled"]))
                          : (_openBlock(), _createBlock(_component_Button, {
                              key: 2,
                              variant: "accent",
                              label: "reserve my spot",
                              class: "!tw-mt-8",
                              onClick: $setup.onSelectDate
                            }, null, 8, ["onClick"])),
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_Text, {
                            variant: "span",
                            textColor: "rgba(12, 15, 74, 0.6)",
                            textAlign: "center"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Terms & Conditions Apply")
                            ]),
                            _: 1
                          })
                        ]),
                        (!$setup.isSportDisable && !$setup.isEligible)
                          ? (_openBlock(), _createBlock(_component_Text, {
                              key: 3,
                              class: "tw-mt-2",
                              textAlign: "center",
                              lineHeight: "18px",
                              variant: "p",
                              textColor: "red"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("You are not eligible for this course. Please check course eligibility to continue.")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
          ]),
          ($setup.eligibilityModal)
            ? (_openBlock(), _createBlock(_component_CheckElegibilityModal, {
                key: 2,
                onOnClose: $setup.toggleElegibilityModal
              }, null, 8, ["onOnClose"]))
            : _createCommentVNode("", true),
          ($setup.entryRequirementsModal)
            ? (_openBlock(), _createBlock(_component_ElegibilityModal, {
                key: 3,
                onOnClose: $setup.toggleElegibilityModal,
                onOnEnroll: $setup.onEnrollCourseSpots
              }, null, 8, ["onOnClose", "onOnEnroll"]))
            : _createCommentVNode("", true),
          ($setup.termsServiceModal)
            ? (_openBlock(), _createBlock(_component_CoursesTermsConditionModal, {
                key: 4,
                onCloseTermsAndConditionModal: $setup.closeTermsAndConditionModal
              }, null, 8, ["onCloseTermsAndConditionModal"]))
            : _createCommentVNode("", true),
          ($setup.isShowWorkstationRestrictionModal)
            ? (_openBlock(), _createBlock(_component_PageRestrictionNoticeModal, {
                key: 5,
                onOnClose: $setup.toggleRestrictionModal
              }, null, 8, ["onOnClose"]))
            : _createCommentVNode("", true),
          ($setup.isShowReserveSpotModal)
            ? (_openBlock(), _createBlock(_component_ReserveSpotsModal, {
                key: 6,
                onOnClose: $setup.closeReserveSpotModal,
                onOnContinue: $setup.onOpenTermsModal
              }, null, 8, ["onOnClose", "onOnContinue"]))
            : _createCommentVNode("", true),
          ($setup.isShowCourseTermsModal)
            ? (_openBlock(), _createBlock(_component_CoursePreEnrollTermsConditionsModal, {
                key: 7,
                onOnReserveSpot: $setup.onReserveSpot,
                onOnBack: $setup.openReserveSpotModal,
                onOnCheckElegibility: $setup.toggleElegibilityModal,
                loading: $setup.isReserving
              }, null, 8, ["onOnReserveSpot", "onOnBack", "onOnCheckElegibility", "loading"]))
            : _createCommentVNode("", true),
          ($setup.isShowSuccessReserveSpotModal && $setup.isPersonalAccountWorkStation)
            ? (_openBlock(), _createBlock(_component_SuccessReserveSpotModal, {
                key: 8,
                onOnClose: $setup.onCloseSuccessReserveSpotModal,
                onOnSelectWs: $setup.openSelectWsModalModal
              }, null, 8, ["onOnClose", "onOnSelectWs"]))
            : _createCommentVNode("", true),
          ($setup.isShowSelectWsModal)
            ? (_openBlock(), _createBlock(_component_SelectWorkstationModal, {
                key: 9,
                onOnBack: $setup.onOpenSuccessReserveSpotModal
              }, null, 8, ["onOnBack"]))
            : _createCommentVNode("", true),
          ($setup.isOpenAssignCourseSlotToMemberModal)
            ? (_openBlock(), _createBlock(_component_AssignCourseSlotToMemberModal, {
                key: 10,
                isfromCourseModule: "",
                selectedUserCourseIdForAssign: $setup.selectedUserCourseIdForAssignMember,
                onOnClickCloseButton: $setup.toggleAssignCourseSlotToMemberModal
              }, null, 8, ["selectedUserCourseIdForAssign", "onOnClickCloseButton"]))
            : _createCommentVNode("", true),
          ($setup.isShowUpgradePremiumModal)
            ? (_openBlock(), _createBlock(_component_TpSubscriptionModal, {
                key: 11,
                onOnClickCloseTab: $setup.toggleUpgradePremiumModal
              }, null, 8, ["onOnClickCloseTab"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}